<template>
  <div class="support page-center">
    <div class="spacer-large"></div>
    <p><a href="/">Home</a></p>
    <br/>
    <br/>
    <h3>Support</h3>
    <p>
      For any comments, questions, or assistance please reach out to
      support@usbclub.net.
    </p>
    <br />
    <p>
      You may also view our
      <a href="/privacy-policy">Privacy Policy</a>, <a href="/terms">Terms of Service</a>, and <a href="/copyright-dispute">Copyright Dispute Policy</a>.
    </p>
    <div class="spacer-3"></div>
    <div class="usb-icon">
      <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="1.5" width="14" height="24.5" rx="1.16667" fill="#B8B8B8"/>
        <rect x="1.41667" y="0.916667" width="15.1667" height="17.5" rx="1.75" stroke="#1C1C1C" stroke-width="1.16667"/>
      </svg>
    </div>
    <div class="spacer-1"></div>
    <p>Any flash drive is subject to wear<br>and tear, please plug-in responsibly.</p>
  </div>
</template>

<script>
export default {
  name: "Support",
  components: {},
  props: {},
  data() {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.support {
  text-align: center;
}

.support p {
  max-width: 376px;
}

.usb-icon {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
